import get from 'lodash/get';
import { handleGetNestedProperty } from './object-methods';

export const GetAllDistinctValuesFromThisArrayOfObjects = <T = Record<string, unknown>>(data: T[], fieldName: keyof T) => [...new Set(data.map((item) => handleGetNestedProperty(item, fieldName.toString())))];
export const GetDistinctValues = <T = Record<string, unknown>>(data: T[], fieldName: keyof T) => {
  const isPrimitive = (value: any) => ['string', 'number', 'boolean'].includes(typeof value);
  if (data.length === 0) return [];

  const firstItemValue = get(data[0], fieldName as string);

  if (isPrimitive(firstItemValue)) {
    const seen = new Set();
    return data
      .map((item) => get(item, fieldName))
      .filter((value) => {
        if (isPrimitive(value) && !seen.has(value)) {
          seen.add(value);
          return true;
        }
        return false;
      });
  } else {
    const uniqueMap = new Map();
    data.forEach((item) => {
      const obj = get(item, fieldName);
      if (obj && !uniqueMap.has(obj.value)) uniqueMap.set(obj.value, obj);
    });
    return [...uniqueMap.values()];
  }
};
